import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ISavedCustomSearch, ICustomCaseSearchOptions } from '../../reports-models';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-saved-searches',
  templateUrl: './saved-searches.component.html',
  styleUrls: ['./saved-searches.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, FormsModule]
})
export class SavedSearchesComponent {

  constructor(
     public matDialog: MatDialog,
     public changeDetector: ChangeDetectorRef
    ) { }
  private dialogRef: MatDialogRef<any, any>;
  selectedSavedSearch = {} as ISavedCustomSearch;

  @ViewChild('saveDialog') saveDialog: any;
  @ViewChild('deleteDialog') deleteDialog: any;

  @Input()
  savedSearches: ISavedCustomSearch[];

  @Output()
  selectedSavedSearchChange = new EventEmitter<ISavedCustomSearch>();

  @Output()
  saveSearch = new EventEmitter<ISavedCustomSearch>();

  @Output()
  deleteSearch = new EventEmitter<number>();

  onClickSavedSearch(savedSearch: ISavedCustomSearch) {
    this.selectedSavedSearch = savedSearch;
    this.selectedSavedSearchChange.emit(savedSearch);
  }

  onSaveSearch() {
    this.selectedSavedSearch = { ...this.selectedSavedSearch };

    this.dialogRef = this.matDialog.open(this.saveDialog, {
      width: '40rem'
    });
  }

  onEmptySelection() {
    this.selectedSavedSearch = { customSearch: {} as ICustomCaseSearchOptions } as ISavedCustomSearch;
    this.changeDetector.markForCheck();
  }

  onUpdateExistingSearch() {
    this.saveSearch.emit(this.selectedSavedSearch);
    this.dialogRef.close();
  }

  onSaveNewSearch() {
    this.selectedSavedSearch.userPreferenceId = 0;
    this.saveSearch.emit(this.selectedSavedSearch);
    this.dialogRef.close();
  }

  onClickDeleteSaved(userPreferenceId: number) {
    this.dialogRef = this.matDialog.open(this.deleteDialog, {
      width: '33rem',
      data: { userPreferenceId }
    });
  }

  onDeleteSavedSearch(data: any) {
    this.deleteSearch.emit(data.userPreferenceId);
    this.dialogRef.close();
  }

  onCloseDeleteDialog() {
    this.dialogRef.close();
  }

  toggleShowDelete(event: any, show: boolean) {
    const deleteIcon = (event.target as HTMLElement).querySelector('i');
    deleteIcon.style.display = show ? "inline" : "none";
  }
}
